import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key';

export const createOrganizationSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    name: z
      .string()
      .min(2, t('organization.validation.nameMinLength'))
      .max(100, t('organization.validation.nameMaxLength'))
      .trim()
      .regex(/^[a-zA-Z0-9äöüÄÖÜß\s\-&'.,]+$/, t('organization.validation.nameCharacters')),
  });
};
